<template>
  <div id="port-select">
    <div class="card vx-card p-6">
      <div class="menu-section">
        <div class="header">
          <div class="title">港湾選択</div>
        </div>
        <div class="description">対象の港湾を選択してください。</div>
        <v-select
          class="port-select-box"
          v-model="selectedPort"
          :options="portOptions"
          :searchable="false"
          label="name"
          placeholder="選択してください"
          :clearable="false">
        </v-select>
        <vs-button
          @click="clickSelectButton"
          color="#2D9CDB"
          :disabled="selectedPort == null || Object.keys(selectedPort).length == 0"
          :to="{name: 'addon-port-master-port-menu'}"
        >
          選択
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMaster")

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      selectedPort: null,
    }
  },
  computed: {
    ...mapState({
      portOptions: state => state.portOptions,
      storedSelectedPort: state => state.selectedPort,
    }),
  },
  created() {
    this.getMasterData()
    this.selectedPort = this.storedSelectedPort
  },
  methods: {
    ...mapActions(["fetchPorts", "selectPort"]),
    clickSelectButton() {
      this.selectPort(this.selectedPort)
    },
    getMasterData() {
      this.fetchPorts()
    }
  }
}
</script>

<style lang="scss">
#port-select {
  .nav-item-top {
    width: 100px;
    padding: 10px;
    color: white;
    background: #2D9CDB;
    border-radius: 6px 0px 0px 6px;
  }
  .vs__search {
    margin: 1px;
    padding: 1px;
  }
  .card {
    margin-top: 30px;
  }
  .menu-section {
    margin: 10px 0px;
  }
  .header {
    display: flex;
    .icon-area {
      width: 45px;
    }
  }
  .menu-button-area {
    margin: 20px 0px;
  }
  .description {
    margin-bottom: 10px;
  }
  .menu-content {
    margin-left: 45px;
  }
  .title {
    font-weight: bold;
    margin-bottom: 15px;
  }
  .item-title {
    font-weight: bold;
    width: 150px;
  }
  .port-select-box {
    width: 200px;
    margin-bottom: 20px;
  }
}
</style>
